module.exports = __webpack_public_path__ + "img/login-tu.59f6f2fd.png";